import React, { useState, useEffect, useRef } from 'react';
import { useHistory, Link } from 'react-router-dom';

import Select from 'react-select';

const optionYear = [
    { value: '0000', label: 'All' },
    { value: '2020', label: '2020' },
    { value: '2019', label: '2019' },
    { value: '2018', label: '2018' }
]

function ProjectsContainer() {
    return(
        <article className="layout-contents-container page-projects stretch">
            <h1 className="hidden">프로젝트 관리</h1>
            
            <div className="projects-state">
                <p className="filters">Project / Year: All / Type: All</p>
                
                <div className="segmented-control">
                    <input type="radio" id="listType01" name="listType" className="control" />
                    <label htmlFor="listType01">List</label>

                    <input type="radio" id="listType02" name="listType" className="control" />
                    <label htmlFor="listType02">Thumbnails</label>
                </div>
            </div>



            {/* 프로젝트 목록 : 리스트 형 */}
            <table className="tbl-projects">
                <caption></caption>
                <thead>
                    <tr>
                        <th className="index">No</th>
                        <th className="title">Project</th>
                        <th className="year">
                            <Select options={optionYear}
                            
                                placeholder="Year"
                                className="THSelect"
                                classNamePrefix="VA"
                                defaultMenuIsOpen={true}
                            />
                        </th>
                        <th className="type">Type</th>
                        <th className="program">Program</th>
                        <th className="location">Location</th>
                    </tr>
                </thead>
                <tbody>
                    <tr>
                        <td className="index">33</td>
                        <th className="title">
                            <Link to="/projects/uid">Domus Korea N.05 Borderless Boundary</Link>
                        </th>
                        <td className="year">2020</td>
                        <td className="type">Publication</td>
                        <td className="program">Book & Magazine</td>
                        <td className="location">Seoul</td>
                    </tr>
                    <tr>
                        <td className="index">33</td>
                        <th className="title">
                            <Link to="/projects/uid">Domus Korea N.05 Borderless Boundary</Link>
                        </th>
                        <td className="year">2020</td>
                        <td className="type">Publication</td>
                        <td className="program">Book & Magazine</td>
                        <td className="location">Seoul</td>
                    </tr>
                    <tr>
                        <td className="index">33</td>
                        <th className="title">
                            <Link to="/projects/uid">Domus Korea N.05 Borderless Boundary</Link>
                        </th>
                        <td className="year">2020</td>
                        <td className="type">Publication</td>
                        <td className="program">Book & Magazine</td>
                        <td className="location">Seoul</td>
                    </tr>
                    <tr>
                        <td className="index">33</td>
                        <th className="title">
                            <Link to="/projects/uid">Domus Korea N.05 Borderless Boundary</Link>
                        </th>
                        <td className="year">2020</td>
                        <td className="type">Publication</td>
                        <td className="program">Book & Magazine</td>
                        <td className="location">Seoul</td>
                    </tr>
                    <tr>
                        <td className="index">33</td>
                        <th className="title">
                            <Link to="/projects/uid">Domus Korea N.05 Borderless Boundary</Link>
                        </th>
                        <td className="year">2020</td>
                        <td className="type">Publication</td>
                        <td className="program">Book & Magazine</td>
                        <td className="location">Seoul</td>
                    </tr>
                    <tr><td colSpan={6} className="none">VALoading</td></tr>
                    <tr><td colSpan={6} className="none txt-c">에러가 발생했습니다.</td></tr>
                    <tr><td colSpan={6} className="none txt-c">등록된 내용이 없습니다.</td></tr>
                </tbody>
            </table>




            {/* 프로젝트 목록 : 썸네일 형 */}
            <ul className="list-projects">
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
                <li>
                    <a href="#" className="project-item">
                        <div className="thumbs" style={{ backgroundImage: "url('/assets/images/@book_thumb_01@2x.jpg')" }}>
                            <div className="inner"><img src="/assets/images/@book_thumb_01@2x.jpg" alt=""/></div>
                        </div>
                        <p className="title">Title</p>
                    </a>
                </li>
            </ul>
        </article>
    );
}

export default ProjectsContainer;
